<div class="flex items-center justify-between">
  <div class="text-xl text-primary font-bold">{{ config.title }}</div>
  <button
    (click)="dialog.close(false)"
    *ngIf="!config.button?.close?.hide"
    class="flex"
    type="button"
  >
    <mat-icon>clear</mat-icon>
  </button>
</div>

<mat-dialog-content class="!py-4">
  <ng-container #container></ng-container>
</mat-dialog-content>

<div
  *ngIf="!config.button?.close?.hide"
  class="flex items-center flex-wrap gap-x-4 gap-y-2 pt-4"
>
  <button
    (click)="dialog.close(true)"
    *ngIf="!config.button?.close?.hide"
    class="portal-button-primary"
    type="button"
  >
    {{ config.button?.close?.label }}
  </button>
</div>
